module.exports = __webpack_public_path__ + "img/grand-palm-spa.7bdcb376.jpg";